/*
 * @Descripttion: 
 * @version: 
 * @Author: ShowE
 * @Date: 2021-05-30 09:42:10
 * @LastEditors: ShowE
 * @LastEditTime: 2021-06-21 19:44:29
 */
exports.install = function (Vue) {
  // Vue.prototype.$target = "http://localhost:7506"; // 本地后端地址
  Vue.prototype.$target = "http://localhost:9090"; // 本地后端地址
  // 封装提示成功的弹出框
  Vue.prototype.notifySucceed = function (msg) {
    this.$notify({
      title: "成功",
      message: msg,
      type: "success",
      offset: 100
    });
  };
  // 封装提示失败的弹出框
  Vue.prototype.notifyError = function (msg) {
    this.$notify.error({
      title: "错误",
      message: msg,
      offset: 100
    });
  };
}
